import React from 'react';
import { arrayOf, node, number, oneOfType, string } from 'prop-types';
import ReactDOM from 'react-dom';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import { TooltipArrow, TooltipContainer } from './styles';
import { usePopperTooltip } from './usePopperTooltip';

const Tooltip = ({ children, content, placement, width }) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip({ placement });

  return (
    <>
      <span ref={setTriggerRef}>{children}</span>
      {visible &&
        ReactDOM.createPortal(
          <TooltipContainer
            width={width}
            ref={setTooltipRef}
            {...getTooltipProps({ className: 'tooltip-container' })}
          >
            {content}
            <TooltipArrow {...getArrowProps({ className: 'tooltip-arrow' })} />
          </TooltipContainer>,
          document.body
        )}
    </>
  );
};

Tooltip.defaultProps = {
  content: null,
  placement: 'top',
  width: 300,
};

Tooltip.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
  content: node,
  placement: string,
  width: number,
};

// eslint-disable-next-line react/prop-types
function TooltipFallback({ children }) {
  return <>{children}</>;
}

export default exportWithBoundary(Tooltip, TooltipFallback);
